import { createFileRoute } from '@tanstack/react-router'
import { NotesPage } from '@/components/notes-page'
export const Route = createFileRoute('/trash')({ component: () => <NotesPage view="trash" /> })
